import ComponentSection from "ui/library/ComponentSection";
import { colors } from "ui/styles/colors";
import styles from "./colors.module.scss";

export default function ColorsComponent() {
  return (
    <ComponentSection>
      <div className={styles.cards}>
        {Object.entries(colors).map(([colorName, colorValue]) => (
          <div key={colorName} className={styles.card}>
            <div className={styles.swatch} style={{ backgroundColor: colorValue }} />
            <div className={styles.label}>className: {colorName}</div>
            <div className={styles.label}>values: {colorValue}</div>
          </div>
        ))}
      </div>
    </ComponentSection>
  );
}
